 <template>
 <el-container class="flex flex-row w-full h-full">
  <el-header class="flex flex-row h-[80px] bg-[#F3F5F7]">
    <div class="bg-no-repeat w-[100px] h-[34px] ml-4 mt-3 bg-cover bg-no-repeat cursor-pointer" style="background-image:url(/images/bst.png);background-size:contain" @click="goHome">
    </div>
    <div class="flex-1"></div>
    <div class="flex flex-row items-center">
      <img src="/images/language.png" class="w-[16px] h-[16px] mr-[10px]"/>
      <span class="text-center text-sm leading-[60px] pr-[20px] text-[#6d6d6d]">简体中文</span>
    </div>
  </el-header>

  <el-main class="w-full h-full bg-[#fafafa]">
    <div class="flex flex-row h-full">
      <div class="flex-1 flex justify-center items-center">
        <div class="w-[450px] bg-white px-[48px] py-[48px] flex flex-col">
          <div><span class="text-[18px]">找回密码</span></div>
          <div>
            <el-steps :space="200" :active="active" finish-status="success" class="mt-[40px] mb-[10px]">
              <el-step title="账号校验"></el-step>
              <el-step title="密码重置"></el-step>
              <el-step title="完成设置"></el-step>
            </el-steps>
          </div>
          <div v-show="active === 0">
            <el-input v-model="mobile" placeholder="请输入手机号" class="pt-[20px] pb-[10px]"></el-input>
            <el-input v-model="code" maxlength="4" placeholder="请输入动态验证码" class="pt-[10px] pb-[10px]"><el-button slot="append" style="font-weight:normal;color:#4f94f7" @click="getVerifyCode()">获取验证码</el-button>
            </el-input>
          </div>
          <div v-show="active === 1">
            <el-input v-model="password" show-password placeholder="请输入新密码" class="pt-[20px] pb-[10px]"></el-input>
            <el-input v-model="rePassword" show-password placeholder="再次输入新密码" class="pt-[20px] pb-[10px]"></el-input>
          </div>
          <div v-show="active === 2" class="text-center">
            <div class="m-[20px]">
              <el-image class="w-[50px] h-[50px]" src="/images/success.png" fit="contain"></el-image>
            </div>
            <div class="mb-[10px]"><span class="text-[20px]">重置密码成功</span></div>
          </div>
          <div class="mt-[20px]">
            <el-button type="primary" @click="nextStep" class="w-full">{{title}}</el-button>
          </div>
          <div>
            <el-link type="primary" class="mt-[10px]" href="/" v-show="active !== 2">返回登录</el-link>
          </div>
        </div>
      </div>
    </div>
  </el-main>
  <el-footer class="h-[45px] bg-[#F3F5F7]">
    <div class="flex justify-center items-center">
      <div class="leading-[45px] pr-[20px] mr-[20px] text-xs text-[#6d6d6d]">Copyright @2024 南京百市通数码科技有限公司</div>
      <div class="leading-[45px] pr-[20px] mr-[10px] text-xs text-[#6d6d6d] sm:block hidden"><a href="#">苏ICP备2023011354号</a></div>
    </div>
  </el-footer>
 </el-container>
</template>

<script>
import {
  getVerifyCode,
  checkVerifyCode,
  updatePassord,
} 
from '@/api/api';

import {
  ErrorVerifyCode,
} from '@/api/consts';

export default {
  name: 'ModifyPasswordPage',
  data() {
    return {
      active: 0,
      mobile: "",
      code: "",
      password: "",
      rePassword: "",
      title: "下一步",
    };
  },
  methods: {
    async nextStep () {
      if (this.active === 0){
        if (!await this.handleCheckVerifyCode()) {
          return
        }
        this.active++;
        return
      }
      if (this.active === 1){
        if (!await this.handleUpdatePassword()) {
          return
        }
        this.active++;
        this.title = "前往登录";
        return
      }
      if (this.active === 2) {
        window.location = "/";
        return;
      }
    },
  
    getVerifyCode() {
      if(!this.testMobile()) {
        return
      }
      const data = JSON.stringify({
        "mobile": this.mobile
      });
      getVerifyCode(data).then(() => {
      this.$message.info("请求已发送，请稍候...");
      })
      .catch(error => {
        console.error("错误信息：", error);
      });
    },

    async handleCheckVerifyCode() {
      if(!this.testMobile()) {
        return
      }
      if(!this.testCode()) {
        return
      }
      const data = JSON.stringify({
        "mobile": this.mobile,
        "code": this.code,
      });
      try {
        let ret = await checkVerifyCode(data);
        if (ret.data.code === 0) {
          return true;
        }
        if (ret.data.code == ErrorVerifyCode){
            this.$message.error("输入的验证码不正确");
            return false;
        } else {
          this.$message.error("无法验证，请核实数据");
          return false;
        }
      }catch(e) {
        console.log(e);
      }
      return false;
    },

    async handleUpdatePassword() {
      if(!this.testPassword()){
        return false;
      }
      const data = JSON.stringify({
        "mobile": this.mobile,
        "code": this.code,
        "password":this.password,
      });
      try {
        let ret = await updatePassord(data);
        console.log(ret)
        if (ret.data.code === 0) {
          return true;
        }
        this.$message.error("更新密码失败");
      }catch(e) {
        console.log(e);
      }
      return false;
    },

    testMobile() {
      this.mobile = this.mobile.trim();
      if (this.mobile == "") {
        this.$message.error("手机号不能为空");
        return false;
      }
      if (this.mobile.length != 11) {
        this.$message.error("手机号长度不正确");
        return false;
      }
      const reg = /^1[0-9]{10}$/;
      if (!reg.test(this.mobile)) {
        this.$message.error("手机号格式不正确");
        return false;
      }
      return true;
    },

    testCode() {
      this.code = this.code.trim();
      if (this.code == "") {
        this.$message.error("验证码不能为空");
        return false;
      }
      if (this.code.length != 4) {
        this.$message.error("验证码长度不正确");
        return false;
      }
      return true;
    },

    testPassword() {
      this.password = this.password.trim();
      if (this.password == "") {
        this.$message.error("密码不能为空");
        return false
      }
      this.rePassword = this.rePassword.trim();
      if (this.rePassword == "") {
        this.$message.error("请再次输入密码确认");
        return false
      }
      if (this.rePassword != this.password) {
        this.$message.error("两次输入的密码不同");
        return false
      }
      return true
    },

    goHome(){
      window.location = "/";
    },
  },
};
</script>

<style scoped>
/deep/ .el-step__title {
  font-weight: normal;
  font-size: 14px;
}
/deep/ .el-step__title.is-process {
  font-weight: normal;
  font-size: 14px;
}
</style>